<template>
    <div class="content-center none-click">
      <div class="banner">
        <div class="banner_box">
            <div class="banner_title">千橙微商城</div>
            <div class="banner_line"></div>
            <div class="banner_text">一款为零售门店打造的专属小程序网店，帮助门店汇聚周边人气，链接周边3-5公里熟人社群，帮助门店实现销量提升</div>
        </div>
        <img src="@/assets/Mobile/images/QcShoppingMall/banner.png" alt="">
      </div>
      <div class="block01" style="background: #F8F8FD;">
        <div class="sk-mobile-title">
          <div class="title">线上商城+社群分销+营销互动 助力零售门店数字化升级</div>
        </div>
        <img class="block02_img" src="@/assets/Mobile/images/QcShoppingMall/block02.png" alt="">
        <div class="content" style="margin-left: 16px;">
          <div class="item">
            <img src="@/assets/Mobile/images/QcShoppingMall/icon1.png" alt="">
            <div class="right">
              <div class="title">专属零售小程序</div>
              <div class="text">独立品牌露出，专属私域运营</div>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/Mobile/images/QcShoppingMall/icon2.png" alt="">
            <div class="right">
              <div class="title">汇享购小程序</div>
              <div class="text">注册即用，免认证一键开店</div>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/Mobile/images/QcShoppingMall/icon3.png" alt="">
            <div class="right">
              <div class="title">社群营销裂变</div>
              <div class="text">丰富的活动工具，助力门店玩转社群运营</div>
            </div>
          </div>
          <div class="item" style="margin-bottom:19px">
            <img src="@/assets/Mobile/images/QcShoppingMall/icon4.png" alt="">
            <div class="right">
              <div class="title">店铺装修想换就换</div>
              <div class="text">海量装修模板，一键应用，丰富的装修组件，个性布局</div>
            </div>
          </div>
        </div>
      </div>
      <div class="block02" style="background-color: #ffffff;">
        <div class="sk-mobile-title">
          <div class="title">更贴近社群场景的营销工具，把社群生意变的简单</div>
        </div>
        <div class="box">
            <div :class="tooItem =='1'?'box_item1':'box_item'" @click="checkBg('1')">
                <div class="box_line"></div>
                <div class="box_text">社群活跃</div>
            </div>
            <div :class="tooItem =='2'?'box_item1':'box_item'" @click="checkBg('2')">
                <div class="box_line"></div>
                <div class="box_text">分销裂变</div>
            </div>
            <div :class="tooItem =='3'?'box_item1':'box_item'" @click="checkBg('3')">
                <div class="box_line"></div>
                <div class="box_text">销量提升</div>
            </div>
            <div :class="tooItem =='4'?'box_item1':'box_item'" @click="checkBg('4')">
                <div class="box_line"></div>
                <div class="box_text">留存复购</div>
            </div>
        </div>
        <div class="content">
            <img v-if="tooItem =='1'" src="@/assets/Mobile/images/QcShoppingMall/block1.png" alt="">
            <img v-if="tooItem =='2'" src="@/assets/Mobile/images/QcShoppingMall/block2.png" alt="">
            <img v-if="tooItem =='3'" src="@/assets/Mobile/images/QcShoppingMall/block3.png" alt="">
            <img v-if="tooItem =='4'" src="@/assets/Mobile/images/QcShoppingMall/block4.png" alt="">
        </div>
      </div>
      <div class="block01" style="background: #F8F8FD;">
        <div class="sk-mobile-title">
          <div class="title">线上线下融合，优势互通促转化</div>
        </div>
        <div class="content">
            <div class="content_box">
                <div class="box_item">
                    <img src="@/assets/Mobile/images/QcShoppingMall/box1.png" alt="">
                    <div class="item_title">一店一码</div>
                    <div class="item_text">引导顾客收藏店铺小程序码，线下没时间，线上随时随地逛门店</div>
                </div>
                <div class="box_item">
                    <img src="@/assets/Mobile/images/QcShoppingMall/box2.png" alt="">
                    <div class="item_title">线上聚单门店自提</div>
                    <div class="item_text">多场景的营销活动在社群等渠道实现线上聚单，门店自提的经营模式</div>
                </div>
                <div class="box_item">
                    <img src="@/assets/Mobile/images/QcShoppingMall/box3.png" alt="">
                    <div class="item_title">线上线下实时互通</div>
                    <div class="item_text">会员资产、营销信息、交易信息全面互通，随地经营，7*24小时在线成交</div>
                </div>
            </div>
        </div>
      </div>
      <img class="content1" src="@/assets/Mobile/images/QcShoppingMall/content1.png" alt="">
      <div class="page_main">
        <div class="sk-mobile-title">
          <div class="title">更多场景功能</div>
        </div>
        <div class="content" style="margin-top: 27px;">
            <img src="@/assets/Mobile/images/QcShoppingMall/main1.png" alt="">
        </div>
      </div>
      <div class="page_main1" style="margin-bottom: 29px;">
        <div class="sk-mobile-title">
          <div class="title">客户案例</div>
        </div>
        <div class="content" style="margin-top: 22px;">
            <img src="@/assets/Mobile/images/QcShoppingMall/case1.png" alt="">
            <img src="@/assets/Mobile/images/QcShoppingMall/case2.png" style="margin-top: 30px;" alt="">
        </div>
      </div>
      <Case title="微商城" />
      <ContactForm info-sources="千橙微商城" />
      <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="千橙微商城" @cancel="modalClose" />
  
    </div>
  </template>
  
  <script>
  import metaInfo from '@/common/util/metaInfo'
  import ContactForm from '@/Mobile/Mobilecom/ContactForm'
  import IndustrySolution from '@/Mobile/Mobilecom/IndustrySolution'
  import Case from '@/Mobile/Mobilecom/Case'
  import TryModal from '@/Mobile/Mobilecom/TryModal'
  
  export default {
    metaInfo: metaInfo.QcShoppingMall,
    components: {
      ContactForm,
      IndustrySolution,
      Case,
      TryModal
    },
    data() {
      return {
        tryVisible: false,
        tooItem:'1',
      }
    },
    mounted() {
  
    },
    methods: {
      checkBg(item) {
        this.tooItem = item;
      },
      openModal: function() {
        this.tryVisible = true
      },
      modalClose: function(data) {
        this.tryVisible = data
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .page_main1{
    background: rgba(234,243,255,.6);
    .content{
        padding: 0 16px;
        img{
            width: 100%;
            height:100%;
        }
    }
  }
  .page_main{
    background-color: #FFFFFF;
    .content{
        padding: 0 16px;
        img{
            width: 100%;
            height:100%;
        }
    }
  }
  .content1{
    width: 100%;
    height:100%;
  }
  .banner_box{
    position: absolute;
    top: 25px;
    left:16px;
    .banner_title{
        height: 25px;
        font-size: 18px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 25px;
        text-align: left;
    }
    .banner_line{
        width: 50px;
        height: 3px;
        background: #28DAFB;
        margin-top:6px;
    }
    .banner_text{
        margin-top:22px;
        width: 134px;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        text-align: left
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .block01 {
    background-color: #FFFFFF;
    .content_box{
        height:240px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0 15px;
        .box_item{
            width:108px;
            img{
                width:108px;
                height:91px;
            }
            .item_title{
                height: 16px;
                font-size: 11px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 16px;
                margin-top:4px;
            }
            .item_text{
                font-size: 8px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #595961;
                line-height: 12px;
            }
        }
        
    }
    .block02_img{
        height:279px;
        width:375px;
        margin-top: 14px
    }
    .content {
      display: flex;
      flex-direction: column;
      .item {
        margin-top: 16px;
        display: flex;
        // justify-content: space-between;
        .title {
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          font-family: PingFangSC, PingFang SC;
          line-height: 20px;
        }
        .text {
          margin-top: 6px;
          font-size: 10px;
          font-weight: 400;
          font-family: PingFangSC, PingFang SC;
          color: #333333;
          line-height: 18px;
        }
      }
      .right {
        margin-left: 18px;
        text-align: left;
      }
    }
    img {
      width: 23px;
      height: 23px;
    }
  }
  .block02{
    background: #D8D8D8;
    .box{
        height:32px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-top: 33px;
        margin-bottom: 33px;
        .box_item{
            width: 76px;
            height: 32px;
            background: #EEEEEE;
            border-radius: 8px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            margin-left: 8px;
            .box_line{
                width: 3px;
                height: 9px;
                background: #CCCCCC;
                border-radius: 2px;
            }
            .box_text{
                width: 48px;
                height: 17px;
                font-size: 12px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #999999;
                line-height: 17px;
                margin-left:5px;
            }
        }
        .box_item1{
            width: 76px;
            height: 32px;
            background: linear-gradient(277deg, #467FE1 0%, #245ACC 100%);
            border-radius: 8px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            margin-left: 8px;
            .box_line{
                width: 3px;
                height: 9px;
                background: #FFFFFF;
                border-radius: 2px;
            }
            .box_text{
                width: 48px;
                height: 17px;
                font-size: 12px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 17px;
                margin-left:5px;
            }
        }
    }
    .content{
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            width: 352px;
            height: 254px;
        }
    }
  }
  .block03 {
    .content {
      padding: 19px 0 25px 0;
      .btns {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        &>div {
          margin: 7px 8px;
          width: 104px;
          height: 39px;
          border-radius: 3px;
          border: 1px solid #8760F1;
          line-height: 39px;
          font-size: 12px;
          font-weight: 400;
          color: #8760F1;
        }
      }
      img {
        margin-top: 19px;
        width: 285px;
      }
    }
  }
   .industry-solution {
      height: 318px;
      background: url("~@/assets/Mobile/images/home/industry-bg.png") no-repeat center;
      background-size: 102%;
      .title {
        color: #fff !important;
      }
      .content {
        padding: 16px 0 14px 0;
        display: flex;
        width: 375px;
        flex-wrap: wrap;
        justify-content: space-evenly;
        .item {
          display: flex;
          flex-direction: column;
          margin: 15px;
          font-size: 12px;
          line-height: 32px;
          color: #FFFFFF;
        }
        img {
          width: 62px;
          height: 62px;
        }
      }
    }
  .block04 {
    background-color: #FAFAFA;
    .content {
      padding: 19px 0 25px 0;
      .btns {
        margin-top: 24px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        &>div {
          margin: 7px 8px;
          width: 104px;
          height: 39px;
          border-radius: 3px;
          border: 1px solid #8760F1;
          line-height: 39px;
          font-size: 12px;
          font-weight: 400;
          color: #8760F1;
        }
      }
      img {
        margin-top: 19px;
        width: 336px;
      }
    }
  }
  .block05 {
    background-color: #FAFAFA;
    .content {
      padding: 28px 16px 20px 16px;
      .item {
        padding: 27px 20px;
        background: #FFFFFF;
        box-shadow: 0px 0px 7px 0px rgba(221, 221, 221, 0.5);
        border-radius: 4px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        img {
          display: block;
          width: 137px;
          height: 164px;
        }
        .left {
          display: flex;
          width: 140px;
          flex-direction: column;
          justify-content: start;
          align-items: flex-start;
          .title {
            font-size: 16px;
            font-weight: 500;
            color: #595961;
            line-height: 23px;
            padding-right: 9px;
            border-right: 1px solid #D8D8D8;
          }
          .sub-title {
            padding-left: 9px;
            font-size: 12px;
            font-weight: 400;
            color: #8B8FA1;
            line-height: 17px;
          }
          .line2 {
            margin-top: 4px;
          }
          .des {
            font-size: 10px;
            font-weight: 400;
            color: #8B8FA1;
            line-height: 14px;
          }
          .num {
            font-size: 16px;
            font-weight: 500;
            color: #FF8C11;
            line-height: 23px;
          }
          .unit {
            font-size: 10px;
            font-weight: 400;
            color: #8B8FA1;
            line-height: 14px;
          }
          .text {
            margin-top: 11px;
            font-size: 10px;
            font-weight: 400;
            color: #595961;
            line-height: 16px;
            text-align: left;
          }
          .btn {
            margin-top: 20px;
            width: 71px;
            height: 22px;
            background: #8760F1;
            border-radius: 3px;
            font-size: 10px;
            color: #FFFFFF;
            line-height: 22px;
          }
        }
      }
    }
  }
  </style>
  